class GallerySliders {
  constructor() {
      if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initializeAll());
      } else {
          this.initializeAll();
      }
      
      // Listen for URL changes (back/forward navigation)
      window.addEventListener('popstate', () => this.handleVariantChange());
      
      // Listen for variant selection changes (if you have variant selectors)
      this.observeVariantChanges();
      
      // Hide gallery initially to prevent flash during JS updates
      this.hideGalleryInitially();
  }

  // Hide gallery initially to prevent flash during JavaScript updates
  hideGalleryInitially() {
      const gallery = document.querySelector('.pdp-media-gallery');
      if (gallery) {
          gallery.style.opacity = '0';
      } else {
          console.warn('Gallery element not found for initial hiding');
      }
  }

  // Show gallery with fade-in animation
  showGalleryWithFadeIn() {
      const gallery = document.querySelector('.pdp-media-gallery');
      if (gallery) {
          // Small delay to ensure all JavaScript processing is complete
          setTimeout(() => {
              gallery.classList.add('fade-in');
          }, 100);
          
          // Safety timeout to ensure gallery is always visible
          setTimeout(() => {
              if (gallery.style.opacity === '0') {
                  gallery.style.opacity = '1';
                  gallery.classList.add('fade-in');
              }
          }, 1000);
      } else {
          console.warn('Gallery element not found for fade-in');
      }
  }

  // Get current variant ID from URL
  getCurrentVariantId() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('variant');
  }

  // Get color for current variant
  getCurrentVariantColor() {
      const variantId = this.getCurrentVariantId();
      if (variantId && window.productColorVariantMap) {
          return window.productColorVariantMap[variantId];
      }
      return null;
  }

  // Get translation for a given key
  getTranslation(key) {
      // Try to get translation from Shopify's translation system
      if (window.Shopify && window.Shopify.translations) {
          const keys = key.split('.');
          let translation = window.Shopify.translations;
          
          for (const k of keys) {
              if (translation && translation[k]) {
                  translation = translation[k];
              } else {
                  break;
              }
          }
          
          if (typeof translation === 'string') {
              return translation;
          }
      }
      
      // Fallback to hardcoded translations based on current language
      const currentLang = document.documentElement.lang || 'en';
      const fallbackTranslations = {
          'en': {
              'general.stock.out_of_stock': 'Out of stock',
              'general.stock.low_stock': 'Low stock'
          },
          'hr': {
              'general.stock.out_of_stock': 'Nema na stanju',
              'general.stock.low_stock': 'Niske zalihe'
          }
      };
      
      return fallbackTranslations[currentLang]?.[key] || key;
  }

  // Get current variant data from the page
  getCurrentVariantData() {
      let currentVariant = null;
      
      // Try to get variant data from variant selector
      const variantSelector = document.querySelector('variant-selects [data-selected-variant]');
      if (variantSelector) {
          try {
              currentVariant = JSON.parse(variantSelector.innerHTML);
          } catch (e) {
              console.warn('Could not parse variant data');
          }
      }
      
      // If no variant data found, try to get from product form
      if (!currentVariant) {
          const productForm = document.querySelector('product-form');
          if (productForm) {
              const variantInput = productForm.querySelector('input[name="id"]');
              if (variantInput && variantInput.value) {
                  // Try to find variant in product data
                  const productData = window.product || {};
                  if (productData.variants) {
                      currentVariant = productData.variants.find(v => v.id.toString() === variantInput.value);
                  }
              }
          }
      }
      
      return currentVariant;
  }

  // Check if the first image matches the current variant color
  isFirstImageCorrectForVariant() {
      const currentVariantColor = this.getCurrentVariantColor();
      if (!currentVariantColor) return true; // If no color variant, assume correct
      
      const firstImage = document.querySelector('.images-grid .first-image, #splide-slider .splide__slide:first-child');
      return firstImage && firstImage.getAttribute('data-color') === currentVariantColor;
  }

  // Add stock label to an element based on variant data
  addStockLabel(element, variant) {
      if (!variant) return;
      
      if (variant.available === false) {
          const stockLabel = document.createElement('div');
          stockLabel.className = 'stock-label out-of-stock';
          stockLabel.textContent = this.getTranslation('general.stock.out_of_stock');
          element.appendChild(stockLabel);
      } else if (variant.inventory_quantity <= 5 && 
                 variant.inventory_quantity > 0) {
          const stockLabel = document.createElement('div');
          stockLabel.className = 'stock-label low-stock';
          stockLabel.textContent = this.getTranslation('general.stock.low_stock');
          element.appendChild(stockLabel);
      }
  }

  // Update stock labels for current variant without reordering images
  updateStockLabelsForCurrentVariant() {
      const currentVariant = this.getCurrentVariantData();
      if (!currentVariant) return;
      
      // Update desktop grid stock label
      const firstGridItem = document.querySelector('.images-grid .first-image');
      if (firstGridItem) {
          // Remove existing stock labels
          const existingLabels = document.querySelectorAll('.images-grid .stock-label');
          existingLabels.forEach(label => label.remove());
          
          // Add new stock label
          this.addStockLabel(firstGridItem, currentVariant);
      }
      
      // Update mobile slider stock label
      const firstMobileSlide = document.querySelector('#splide-slider .splide__slide:first-child');
      if (firstMobileSlide) {
          // Remove existing stock labels
          const existingLabels = document.querySelectorAll('#splide-slider .stock-label');
          existingLabels.forEach(label => label.remove());
          
          // Add new stock label
          this.addStockLabel(firstMobileSlide, currentVariant);
      }
  }

  // Observe for variant changes in the URL or variant selectors
  observeVariantChanges() {
      let currentVariantColor = this.getCurrentVariantColor();
      
      // Check for URL changes periodically (fallback for pushState)
      setInterval(() => {
          const newVariantColor = this.getCurrentVariantColor();
          if (newVariantColor !== currentVariantColor && newVariantColor) {
              currentVariantColor = newVariantColor;
              this.handleVariantChange();
          }
      }, 100);
      
              // Also listen for variant selector changes if they exist
        const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
        variantSelectors.forEach(selector => {
            selector.addEventListener('change', () => {
                setTimeout(() => this.handleVariantChange(), 50);
            });
        });
        
        // Listen for custom variant change events from product-info
        document.addEventListener('product-info:variant-changed', () => {
            setTimeout(() => this.handleVariantChange(), 50);
        });
    }

  // Handle variant change by reordering images
  handleVariantChange() {
      const currentVariantColor = this.getCurrentVariantColor();
      if (currentVariantColor) {
          // Ensure gallery is visible during variant changes
          const gallery = document.querySelector('.pdp-media-gallery');
          if (gallery) {
              gallery.style.opacity = '1';
          }
          
          // Check if the first image already matches the current variant color
          if (this.isFirstImageCorrectForVariant()) {
              // Images are already in correct order, just update stock labels
              this.updateStockLabelsForCurrentVariant();
          } else {
              // Need to reorder images
              this.reorderImagesForColor(currentVariantColor);
          }
          
          // Add a subtle fade effect after processing
          setTimeout(() => {
              if (gallery) {
                  gallery.style.transition = 'opacity 0.3s ease-in-out';
                  gallery.style.opacity = '0.8';
                  setTimeout(() => {
                      gallery.style.opacity = '1';
                  }, 150);
              }
          }, 50);
      } else {
          // If no color change, just update stock labels for current variant
          this.updateStockLabelsForCurrentVariant();
      }
  }

  // Reorder images to put selected color image first
  reorderImagesForColor(color) {
      this.reorderMobileSlider(color);
      this.reorderDesktopGrid(color);
  }

  // Reorder mobile slider
  reorderMobileSlider(color) {
      const splideSlider = document.querySelector('#splide-slider');
      if (!splideSlider) return;

      const slides = Array.from(splideSlider.querySelectorAll('.splide__slide'));
      const splideList = splideSlider.querySelector('.splide__list');
      
      // Find the slide with matching color
      const targetSlide = slides.find(slide => 
          slide.getAttribute('data-color') === color
      );
      
      if (targetSlide && slides[0] !== targetSlide) {
          // Move target slide to first position
          splideList.insertBefore(targetSlide, slides[0]);
          
                      // Update data-index attributes
            const updatedSlides = Array.from(splideList.querySelectorAll('.splide__slide'));
            updatedSlides.forEach((slide, index) => {
                slide.setAttribute('data-index', index.toString());
            });
            
            // Update stock label for mobile slider
            this.updateMobileStockLabel(targetSlide);
            
            // Reinitialize the mobile slider if it exists
            if (this.mobileSliderInstance) {
                this.mobileSliderInstance.destroy();
            }
            this.initMobilePdpGallerySlider();
      }
  }

  // Reorder desktop grid
  reorderDesktopGrid(color) {
      const imagesGrid = document.querySelector('.images-grid');
      if (!imagesGrid) return;

      const gridItems = Array.from(imagesGrid.querySelectorAll('[class*="grid-item-"]:not(.placeholder-image)'));
      
      // Find the grid item with matching color
      const targetItem = gridItems.find(item => 
          item.getAttribute('data-color') === color
      );
      
      if (targetItem && gridItems[0] !== targetItem) {
          // Get the first item's position
          const firstItem = gridItems[0];
          
          // Swap the positions in DOM
          const parent = targetItem.parentNode;
          const targetNextSibling = targetItem.nextSibling;
          
          parent.insertBefore(targetItem, firstItem);
          parent.insertBefore(firstItem, targetNextSibling);
          
          // Update class names to maintain grid positioning
          this.updateGridItemClasses();
          
          // Update first-image class
          gridItems.forEach(item => item.classList.remove('first-image'));
          targetItem.classList.add('first-image');
          
          // Move stock label to new first image
          this.moveStockLabel(targetItem);
      }
  }

  // Update grid item class names after reordering
  updateGridItemClasses() {
      const imagesGrid = document.querySelector('.images-grid');
      if (!imagesGrid) return;

      const gridItems = Array.from(imagesGrid.querySelectorAll('[class*="grid-item-"]:not(.placeholder-image)'));
      
      gridItems.forEach((item, index) => {
          // Remove existing grid-item classes
          const classList = Array.from(item.classList);
          classList.forEach(className => {
              if (className.startsWith('grid-item-')) {
                  item.classList.remove(className);
              }
          });
          
          // Add new grid-item class
          item.classList.add(`grid-item-${index + 1}`);
      });
  }

  // Update mobile slider stock label
  updateMobileStockLabel(newFirstSlide) {
      // Remove existing stock labels from mobile slider
      const existingLabels = document.querySelectorAll('#splide-slider .stock-label');
      existingLabels.forEach(label => label.remove());
      
      // Get current variant data and add stock label
      const currentVariant = this.getCurrentVariantData();
      this.addStockLabel(newFirstSlide, currentVariant);
  }

  // Move stock label to new first image
  moveStockLabel(newFirstItem) {
      // Remove existing stock labels
      const existingLabels = document.querySelectorAll('.images-grid .stock-label');
      existingLabels.forEach(label => label.remove());
      
      // Get current variant data and add stock label
      const currentVariant = this.getCurrentVariantData();
      this.addStockLabel(newFirstItem, currentVariant);
  }

  initMobilePdpGallerySlider() {
      const mobileSliderOptions = {
          arrows: false,
          pagination: false,
      };
  
      if (window.location.href.includes('gift-card')) {
          mobileSliderOptions.focus = 'center';
      }
  
      const sliderElement = document.querySelector('#splide-slider');
      if (sliderElement) {
          this.mobileSliderInstance = new Splide('#splide-slider', mobileSliderOptions);
          this.mobileSliderInstance.mount();
      }
  }

  handleSplideSlider() {
      const mediaModal = document.querySelector("#media-modal");

      if (mediaModal) {
          mediaModal.splideInstance = new Splide(mediaModal, {
              type: 'slide',
              perPage: 1,
              perMove: 1,
              mobileFirst: true,
              arrows: true,
              pagination: false,
              breakpoints: {
                  992: {
                      perPage: 1,
                      centerMode: true,
                      variableWidth: false,
                  },
              },
          }).mount();
      }
  }
  
    initModal() {
        this.openModal = (slideIndex) => {
            const modal = document.getElementById('media-modal');
            const header = document.getElementById('shopify-section-header');
            
            if (modal && header) {
                modal.classList.add('active');
                document.body.style.overflow = 'hidden';
                header.style.zIndex = '10';
                
                if (modal.splideInstance) {
                    modal.splideInstance.destroy();
                }
                
                if (!modal.originalSlideOrder) {
                    modal.originalSlideOrder = Array.from(modal.querySelectorAll('.splide__slide')).map(slide => slide.cloneNode(true));
                }
                
                const modalList = modal.querySelector('.splide__list');
                modalList.innerHTML = '';
                modal.originalSlideOrder.forEach(slide => {
                    modalList.appendChild(slide.cloneNode(true));
                });
                
                const modalSlides = Array.from(modal.querySelectorAll('.splide__slide'));
                if (slideIndex > 0 && modalSlides[slideIndex]) {
                    const targetSlide = modalSlides[slideIndex];
                    modalList.insertBefore(targetSlide, modalSlides[0]);
                    
                    const updatedSlides = Array.from(modalList.querySelectorAll('.splide__slide'));
                    updatedSlides.forEach((slide, index) => {
                        slide.setAttribute('data-index', index.toString());
                    });
                }
                
                modal.splideInstance = new Splide(modal, {
                    type: 'slide',
                    perPage: 1,
                    perMove: 1,
                    mobileFirst: true,
                    arrows: true,
                    pagination: false,
                    start: 0,
                    breakpoints: {
                        992: {
                            perPage: 1,
                            centerMode: true,
                            variableWidth: false,
                        },
                    },
                }).mount();
            }
        };

        this.closeModal = () => {
            const modal = document.getElementById('media-modal');
            const header = document.getElementById('shopify-section-header');
            if (modal) {
                modal.classList.remove('active');
                document.body.style.overflow = 'unset';
                header.style.zIndex = '100';
            }
        };
        
        document.querySelectorAll('#splide-slider .slider-item img, #splide-slider .slider-item video').forEach((media) => {
            media.addEventListener('click', (e) => {
                const slide = e.target.closest('.splide__slide');
                const slideIndex = parseInt(slide.getAttribute('data-index')) || 0;
                
                this.openModal(slideIndex);
            });
        });

        window.closeModal = this.closeModal;

        const mediaModal = document.getElementById('media-modal');
        if (mediaModal) {
            mediaModal.addEventListener('click', (e) => {
                if (e.target === e.currentTarget || e.target.classList.contains('media-modal-close')) {
                    this.closeModal();
                }
            });
        }
    }
    
  desktopModal() {
      const modal = document.getElementById('image-modal');
      const modalImage = document.getElementById('modal-image-desktop');
      const closeModal = document.querySelector('.close-modal');
      const triggers = document.querySelectorAll('.modal-trigger');

      if (!modal || !modalImage || !closeModal) return;

      triggers.forEach(trigger => {
          trigger.addEventListener('click', function () {
              // Check if this is a video trigger
              const isVideo = this.classList.contains('video-container') || this.querySelector('video');
              
              if (isVideo) {
                  // Handle video in the same modal
                  const video = this.querySelector('video');
                  if (video) {
                      // Replace the modal content with video
                      modalImage.style.display = 'none';
                      const videoElement = video.cloneNode(true);
                      videoElement.controls = false;
                      videoElement.autoplay = true;
                      videoElement.loop = true;
                      videoElement.muted = true;
                      videoElement.style.width = 'auto';
                      videoElement.style.height = '100%';
                      videoElement.style.maxWidth = '100%';
                      videoElement.style.maxHeight = '80vh';
                      
                      // Remove existing video if any
                      const existingVideo = modal.querySelector('.modal-content video');
                      if (existingVideo) {
                          existingVideo.remove();
                      }
                      
                      // Add video to modal-content div
                      const modalContent = modal.querySelector('.modal-content');
                      modalContent.appendChild(videoElement);
                      
                      // Show modal
                      modal.classList.remove('hidden');
                      modal.classList.add('modal-enter');
                      setTimeout(() => {
                          modal.classList.add('modal-enter-active');
                          modal.classList.remove('modal-enter');
                      }, 10);
                  }
              } else {
                  // Handle image modal
                  // Remove any existing video
                  const existingVideo = modal.querySelector('.modal-content video');
                  if (existingVideo) {
                      existingVideo.remove();
                  }
                  
                  modalImage.style.display = 'block';
                  modalImage.src = this.src;
                  modal.classList.remove('hidden');
                  modal.classList.add('modal-enter');
                  setTimeout(() => {
                      modal.classList.add('modal-enter-active');
                      modal.classList.remove('modal-enter');
                  }, 10);
              }
          });
      });

      closeModal.addEventListener('click', function () {
          closeWithAnimation();
      });

      modal.addEventListener('click', function (e) {
          if (e.target === modal) {
              closeWithAnimation();
          }
      });

      function closeWithAnimation() {
          modal.classList.add('modal-exit-active');
          modal.classList.remove('modal-enter-active');
          setTimeout(() => {
              modal.classList.add('hidden');
              modal.classList.remove('modal-exit-active');
          }, 300);
      }
  }


  
  initializeAll() {
      this.initMobilePdpGallerySlider();
      this.initModal();
      this.handleSplideSlider();
      this.desktopModal();
      
      // Handle initial variant if present in URL
      const initialVariantColor = this.getCurrentVariantColor();
      if (initialVariantColor) {
          // Process initial variant change first
          this.handleVariantChange();
          // Show gallery after variant processing
          setTimeout(() => this.showGalleryWithFadeIn(), 200);
              } else {
            // No initial variant, ensure stock labels are correct and show gallery
            setTimeout(() => this.updateStockLabelsForCurrentVariant(), 100);
            this.showGalleryWithFadeIn();
        }
  }
}

// Initialize
let gallerySlider = new GallerySliders();